import { type RefObject, useEffect, useState } from 'react'

const DESKTOP = '(min-width: 64rem)'

/** Height from an element's top edge to the bottom of the viewport, tracked through scroll and layout changes. */
export function useViewportFillHeight(ref: RefObject<HTMLElement | null>): number | undefined {
  const [height, setHeight] = useState<number>()

  useEffect(() => {
    const desktop = window.matchMedia(DESKTOP)

    function update() {
      if (!ref.current || !desktop.matches) return setHeight(undefined)
      setHeight(window.innerHeight - Math.max(ref.current.getBoundingClientRect().top, 0))
    }

    update()
    const observer = new ResizeObserver(update)
    observer.observe(document.body)
    window.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    desktop.addEventListener('change', update)
    return () => {
      observer.disconnect()
      window.removeEventListener('scroll', update)
      window.removeEventListener('resize', update)
      desktop.removeEventListener('change', update)
    }
  }, [ref])

  return height
}
